import React, { Component } from 'react';
import './ConfiguratorSection.css';

class ConfiguratorOption extends Component {
  render() {
    return (
      <div className="option" style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}

export default ConfiguratorOption;


// WEBPACK FOOTER //
// ./src/ConfiguratorOption.js